import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { useLang } from "@/contexts/LangContext";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";
import "@/lib/i18n_p1";
import { CheckCircle2, AlertTriangle, Clock, ArrowRight } from "lucide-react";

export default function AreebaResult() {
  const { lang } = useLang();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get("status") || "error";
  const orderId = params.get("order_id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (status === "paid") refresh();
    if (orderId) {
      api.get(`/areeba/order/${orderId}`).then(({ data }) => setOrder(data)).catch(() => {});
    }
  }, [status, orderId, refresh]);

  const ui = {
    paid:   { Icon: CheckCircle2, color: "text-[#C65D47]", title: t(lang,"billing.success_title"),  sub: t(lang,"billing.success_sub"), cta: t(lang,"billing.go_dashboard"), to: "/dashboard" },
    pending:{ Icon: Clock,        color: "text-[#0A1128]", title: "Payment is still processing",  sub: "We'll activate your plan as soon as Areeba confirms the payment.", cta: t(lang,"billing.go_dashboard"), to: "/dashboard" },
    failed: { Icon: AlertTriangle,color: "text-[#C65D47]", title: "Payment failed",               sub: "Your card was not charged. You can try again from the pricing page.", cta: "Back to pricing", to: "/pricing" },
    error:  { Icon: AlertTriangle,color: "text-[#C65D47]", title: "Verification error",           sub: "We couldn't verify the transaction with Areeba. Contact support if this persists.", cta: "Back to pricing", to: "/pricing" },
  }[status] || { Icon: AlertTriangle, color: "text-[#C65D47]", title: "Unknown status", sub: "", cta: "Back to pricing", to: "/pricing" };

  const { Icon } = ui;
  return (
    <AppShell>
      <div className="max-w-xl mx-auto bg-white border border-[#E9ECEF] p-10 text-center" data-testid="areeba-result-card">
        <Icon className={`w-12 h-12 mx-auto ${ui.color}`} />
        <h1 className="mt-6 font-display text-3xl">{ui.title}</h1>
        <p className="mt-2 text-[#495057]">{ui.sub}</p>
        {order && (
          <p className="mt-3 text-xs text-[#868E96]">Order {order.order_id} · {order.currency} {order.amount}</p>
        )}
        <button onClick={() => navigate(ui.to)} className="mt-8 inline-flex items-center gap-2 bg-[#0A1128] text-white px-6 py-3 hover:bg-[#1C2538]" data-testid="areeba-result-cta">
          {ui.cta} <ArrowRight className="w-4 h-4" />
        </button>
        <p className="mt-6 text-xs text-[#868E96]">
          Need help? <Link to="/settings" className="underline">Contact us</Link>
        </p>
      </div>
    </AppShell>
  );
}
